import React from 'react'

import { Page } from '../../../../components/layouts/page'
import { Column } from '../../../../components/layouts/columns'
import { Form } from '../../../../components/ui/form'
import { FormReports } from './form/formReports'
import useAddReports from './hooks/useAdminAddReports'

export const AdminAddReports = () => {
  const { loading, formContext, setFormContext, HandleAddReports } = useAddReports()

  return (
    <Page.Section className="is-fullheight-with-navbar">
      <Form.Root
        action={() => {
          HandleAddReports()
        }}
      >
        <Column.Root>
          <Column.Content>
            <p className="subtitle is-size-3">Adicionar Relatório</p>
          </Column.Content>
        </Column.Root>
        <FormReports loading={loading} values={formContext} setValues={setFormContext} disabledList={{}} />
      </Form.Root>
    </Page.Section>
  )
}
